import { render, staticRenderFns } from "./ShiftAdvancedOptions.vue?vue&type=template&id=7c838b96&"
import script from "./ShiftAdvancedOptions.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ShiftAdvancedOptions.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports